import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';
import {
  normalizeDreamflyImageCatalog,
  normalizeDreamflyLlmCatalog,
} from '../constants/dreamflyModels';

export const DREAMFLY_IMAGE_MODELS_ENDPOINT = (
  import.meta.env.VITE_DREAMFLY_IMAGE_MODELS_ENDPOINT
  || `${API_HOST}/api/dreamfly/models?type=image`
);

export const DREAMFLY_LLM_MODELS_ENDPOINT = (
  import.meta.env.VITE_DREAMFLY_LLM_MODELS_ENDPOINT
  || `${API_HOST}/api/dreamfly/models?type=llm`
);

let inFlightDreamflyLlmCatalogRequest = null;
let inFlightDreamflyImageCatalogRequest = null;

export const fetchDreamflyImageModels = async () => {
  if (!inFlightDreamflyImageCatalogRequest) {
    inFlightDreamflyImageCatalogRequest = authenticatedFetch(DREAMFLY_IMAGE_MODELS_ENDPOINT)
      .then(normalizeDreamflyImageCatalog)
      .finally(() => {
        inFlightDreamflyImageCatalogRequest = null;
      });
  }
  return inFlightDreamflyImageCatalogRequest;
};

export const fetchDreamflyLlmModels = async () => {
  if (!inFlightDreamflyLlmCatalogRequest) {
    inFlightDreamflyLlmCatalogRequest = authenticatedFetch(DREAMFLY_LLM_MODELS_ENDPOINT)
      .then(normalizeDreamflyLlmCatalog)
      .finally(() => {
        inFlightDreamflyLlmCatalogRequest = null;
      });
  }
  return inFlightDreamflyLlmCatalogRequest;
};
